<template>
  <div style="display: flex; align-items: center">
    <label style="padding-right: 2%; width: 18%">{{ label }}</label>
    <div class='container'>
      <input type='checkbox' class='check' @click="toggle" />
      <div class='box' @click="toggle">{{this.selectedValue.label}}</div>
    </div>
  </div>
</template>

<script>
 import { library } from '@fortawesome/fontawesome-svg-core'
 import { faLock } from "@fortawesome/free-solid-svg-icons";

 library.add(faLock);

  export default {
      name: 'CustomCheckboxField',
      props: ['selected', 'other', 'label'],
      data: function () {
          return {
              selectedValue: '',
              otherValue: '',
          };
      },
      mounted(){
        this.selectedValue = this.selected;
        this.otherValue = this.other;
      },
      methods: {
        toggle(){
          const tmp = this.selectedValue;
          this.selectedValue = this.otherValue;
          this.otherValue = tmp;
        }
      }
  }

</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';

  .container
    display flex
    justify-content center
    align-items center

    width 100%
    margin-left -20%

  .check
    opacity 0
    width 100px
    height 30px
    z-index 2
    cursor pointer

  .box
    position absolute
    display flex
    justify-content center
    align-items center
    width 150px
    height CTRL_HEIGHT
    background-color THEME_COLOR_PRIMARY
    transition all .5s
    overflow hidden
    border-radius CTRL_RADIUS
    color white

  .box::before
    position absolute
    color white
    transition all .5s


  .box::after
    position absolute
    color gray
    top 43px
    transition all .5s

  .check:checked + .box::before,
  .check:checked + .box::after
    transform translateY(-37px)

  .check:checked + .box::before
    color gray

  .check:checked + .box::after
    color white

  .check:checked + .box
    background-color THEME_COLOR_PRIMARY_FADDED

  input:checked + label
    animation linear .5s slide-out
    opacity 1

  @keyframes slide-out
    from
      transform translateY(0)
      opacity 1

    to
      transform translateY(-30px)
      opacity 0

  @keyframes slide-in
    from
      transform translateY(30px)
      opacity 0

    to
      transform translateY(0)
      opacity 1
</style>
